var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('resource',{attrs:{"resource":"user","attributes":[
      {
        name: 'name',
        label: 'Name'
      },
      {
        name: 'email',
        label: 'Email'
      },
      {
        name: 'password',
        label: 'Password'
      },
      {
        name: 'roles',
        label: 'Rollen',
        type: 'RoleSelector'
      },
      {
        name: 'permissions',
        label: 'Berechtigungen',
        type: 'PermissionSelector'
      }
    ]},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h4',[_vm._v("Systembenutzer Erstellen")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }